<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding">
      <h1 class="ion-no-margin">
        {{ $t('onboarding.welcome') }} {{ user.customer.data.name }}
      </h1>
      <p v-html="$t('onboarding.privacy')" />
      <ion-button
        class="ion-margin-top"
        expand="block"
        @click="skip"
      >
        {{ $t('onboarding.agree') }}
      </ion-button>

      <ion-grid class="ion-no-padding ion-margin-top-sm">
        <ion-row>
          <ion-col>
            <ul class="progress">
              <li />
              <li />
              <li />
              <li />
              <li class="active" />
            </ul>
          </ion-col>
          <ion-col class="ion-text-end">
            <ion-button
              fill="clear"
              color="medium"
              class="ion-no-margin ion-no-padding"
              @click="abort"
            >
              {{ $t('onboarding.disagree') }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonFooter, modalController, alertController,
} from '@ionic/vue';
import { format } from 'date-fns';
import AuthService from '@/services/Auth';
import UserService from '@/services/User';
import store from '@/store';

export default defineComponent({
  components: {
    IonFooter,
  },
  computed: {
    user: () => store.user,
  },
  methods: {
    /**
     * Abort onboarding.
     */
    async abort() {
      const alert = await alertController.create({
        message: this.$t('onboarding.privacy'),
        buttons: [
          {
            text: this.$t('onboarding.logout'),
            role: 'cancel',
            handler: this.logout,
          },
          {
            text: this.$t('onboarding.delete'),
            handler: this.delete,
          },
          {
            text: this.$t('onboarding.agree'),
            handler: this.skip,
          },
        ],
      });
      await alert.present();
    },
    /**
     * Delete data.
     */
    async delete() {
      await UserService.delete();
      await this.logout();
    },
    /**
     * Log out.
     */
    async logout() {
      await AuthService.clearStorage();
      await modalController.dismiss();
      this.$router.go();
    },
    /**
     * Skip onboarding.
     */
    async skip() {
      await Promise.all([
        UserService.updateProfile([
          { key: 'name', value: this.user.customer.data.name },
          { key: 'preposition', value: this.user.customer.data.preposition ?? '' },
          { key: 'surname', value: this.user.customer.data.surname },
          { key: 'birthday', value: this.user.customer.data.birthday ? format(new Date(this.user.customer.data.birthday), 'yyyy-MM-dd') : null },
          { key: 'street', value: this.user.customer.data.street },
          { key: 'house_number', value: this.user.customer.data.house_number },
          { key: 'house_number_addition', value: this.user.customer.data.house_number_addition },
          { key: 'postal_code', value: this.user.customer.data.postal_code },
          { key: 'city', value: this.user.customer.data.city },
          { key: 'country', value: this.user.customer.data.country },
          { key: 'language', value: this.user.customer.data.language },
          { key: 'email', value: this.user.customer.data.email },
          { key: 'phone_number', value: this.user.customer.data.phone_number },
        ]),
        UserService.updateBoarded(),
      ]);
      await modalController.dismiss();
      await this.$router.push('/');
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}
</style>
